import { BaseModalInterface } from './base-modal.interface';

export interface RewardsModalInterface extends BaseModalInterface {
  cashback: number;
  isMobile: boolean;
}
